const drawGeoPathForRoute = (ctx, path, lineStringPointsGeoJson) => {
  ctx.beginPath();
  path(lineStringPointsGeoJson);
  ctx.lineWidth = 4;
  ctx.strokeStyle = '#987AD5';
  ctx.stroke();
};

export { drawGeoPathForRoute };
